module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-red.f3350ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-red.svg
// module id = YluA
// module chunks = 82